//import router from "@/router";

export default {
    namespaced: true,
    state: {
        token: '',
        user: '',
        status: '',
    },
    mutations: {
        AUTH_REQUEST: (state) => {
            state.status = 'loading';
        },
        AUTH_SUCCESS: (state, data) => {
            if (data.token) {
                state.token = data.token;
            } else {
                state.token = data.accessToken;
            }
            state.status = 'success';
            state.user = data.user;
        },
        AUTH_ERROR: (state) => {
            state.status = 'error';
        },
        AUTH_LOGOUT: (state) => {
            state.status = '';
            state.token = '';
            state.user = {};
        },
    },
    actions: {
        // eslint-disable-next-line no-unused-vars
        AUTH_REQUEST: ({ commit, dispatch }, user) => {},
        // eslint-disable-next-line no-unused-vars
        AUTH_LOGOUT: ({ commit, dispatch }) => {},
    },
    getters: {
        isAuthenticated: (state) => !!state.token,
        isAdmin: (state) => state.user.is_admin,
        isStaff: (state) => state.user.is_staff,
    },
    modules: {},
};